import api from './client'

// CLIENTES → Wine Club: socios y membresías, gestionados desde LGR y
// replicados en Mobbex (pausar / reactivar / cambiar de nivel / precios).
export const wineClubApi = {
  socios: (params) => api.get('/wine-club/socios', { params }),
  // Socios OFFLINE: pagan por fuera de toda pasarela; LGR genera su NV mensual
  // en la fecha pactada (viven solo en LGR). El importe no viaja: es el valor
  // de la membresía (precio del nivel).
  altaOffline: (body) => api.post('/wine-club/socios/offline', body),
  editarOffline: (id, body) => api.put(`/wine-club/socios/${id}/offline`, body),
  pausar: (id) => api.post(`/wine-club/socios/${id}/pausar`),
  reactivar: (id) => api.post(`/wine-club/socios/${id}/reactivar`),
  cambiarNivel: (id, nivel) => api.post(`/wine-club/socios/${id}/cambiar-nivel`, { nivel }),
  avisarTarjeta: (id) => api.post(`/wine-club/socios/${id}/avisar-tarjeta`),
  // Cobros que Mobbex no pudo hacer: se ven en la ficha, se reintentan a mano
  // y se cierran diciendo qué pasó (LGR no reintenta el pasado solo).
  cobrosFallidos: (id) => api.get(`/wine-club/socios/${id}/cobros-fallidos`),
  reintentarCobro: (falloId) => api.post(`/wine-club/cobros-fallidos/${falloId}/reintentar`),
  resolverCobro: (falloId, motivo) => api.post(`/wine-club/cobros-fallidos/${falloId}/resolver`, { motivo }),
  niveles: () => api.get('/wine-club/niveles'),
  precio: (nivel, precio) => api.put(`/wine-club/niveles/${nivel}/precio`, { precio }),
}
